<template>
<div class="card-container" :class="{ 'card-container--selected': selected }">
  <div class="card-container--img">
    <img src="../../../public/img/icons/hermes-icon-line.png" />
  </div>
  <div class="card-container--name">
    <p>{{ department.nome_setor }}</p>
  </div>
</div>

</template>

<script>
export default {
  data() {
    return {
    };
  },
  components: {},
  props: ["department", 'selected'],
};
</script>

<style scoped>
.card-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 33%;
  min-width: 230px;
  max-width: 260px;
  height: 330px;
  background-color: #EDF0F8;
  border-radius: 3px;
  font-family: 'poppins', sans-serif;
  box-shadow: 4px 4px 4px 0px #0000000F;

}
.card-container:hover {
  /* background-color: #EDF0F8; */
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.255);
  cursor: pointer;
  transition: all 0.3s ease;
  /* transform: scale(1.05); */
}

.card-container--selected{
  border: 3.5px solid #e76852;
  transition: all 0.3s ease;  
}

.card-container--img{
  height: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  img{
    width: 30%;
    /* height: 30%; */
  }
}

.card-container--name{
  height: 40%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  
  p{
    color: #413f3f
  }
}


</style>